import { useParams } from "react-router-dom";
import { useFetchDocuments } from "../../../hooks/clients.queries";
import { ClientDocumentType } from "../../../types/clients.types";
import DocumentViewer from "../../../../../components/DocumentViewer/DocumentViewer";

export default function InsuranceDocument() {
    const params = useParams();
    const clientId = params.clientId as string;
    const documentId = params.documentId as string;

    const { data } = useFetchDocuments({
        client_id: clientId,
        type: ClientDocumentType.INSURANCE_SCAN,
    });

    const documentInViewDetails = data?.data.find(
        (document) => document.document_id === documentId
    );

    return (
        <div className="page">
            {documentInViewDetails?.metadata?.content_type &&
            /^image/.test(documentInViewDetails?.metadata?.content_type) ? (
                <p className="font-medium text-lg text-center capitalize underline mb-12">
                    {documentInViewDetails?.title}
                </p>
            ) : null}

            <DocumentViewer
                document={documentInViewDetails}
                file={documentInViewDetails?.url}
            />
        </div>
    );
}
